import React, {Fragment, useRef} from 'react';
import { useForm } from "react-hook-form";
import emailjs  from "@emailjs/browser";


const ProjectForm = () => {
    const [
        isSuccessfullySubmitted,
        setIsSuccessfullySubmitted,
    ] = React.useState(false);
    const [
        isSubmitting,
        setIsSubmitting
    ] = React.useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur"
    });
    const form = useRef();
    const onSubmit = () => {
        setIsSubmitting(true);
        emailjs.sendForm('service_rfb3e39', 'template_omgbepv', form.current, 'AMTVJAlBgzfzGWJ2m')
            .then((result) => {
                console.log(result.text);
                setIsSubmitting(false);
                setIsSuccessfullySubmitted(true);
            }, (error) => {
                setIsSubmitting(false);
                console.log(error.text);
            });
    };
    
    return (
        <Fragment>
            {!isSuccessfullySubmitted && (
            <form ref={form} onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-n4">
                    <div className="col-md-12 col-12 mb-4">
                        <input 
                            type="text" 
                            placeholder="Your Name *" 
                            name="name" 
                            {...register("name", {
                                required: "Name is required",
                            })} 
                        />
                        {errors?.name && <p>{errors.name?.message}</p>}
                    </div>
                    <div className="col-md-12 col-12 mb-4">
                        <input 
                            type="email" 
                            placeholder="Email *" 
                            name="email" 
                            {...register("email", {
                                required: "Email is required",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                    message: "invalid email address",
                                },
                            })} 
                        />
                        {errors?.email && <p>{errors.email?.message}</p>}
                    </div>
                    <div className="col-md-12 col-12 mb-4">
                        <input
                            type="tel"
                            placeholder="Phone Number *"
                            name="phone"
                            {...register("phone", {
                                required: "Phone Number",
                                pattern: {
                                    value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i,
                                    message: "invalid phone number",
                                },
                            })}
                        />
                        {errors?.phone && <p>{errors.phone?.message}</p>}
                    </div>
                    <div className="col-12 mb-6">
                        <textarea 
                            name="message" 
                            placeholder="Tell us more about your project"
                            {...register("message", {
                                required: "Message is required",
                            })}
                        ></textarea>
                        {errors?.message && <p>{errors.message?.message}</p>}
                    </div>
                    <div className="col-12 text-center mb-4">
                        <button type="submit" className="btn btn-primary btn-hover-secondary">
                            {isSubmitting && (
                                <span className="spinner-border spinner-border-sm m5"></span>
                            )}
                            Get a free estimate
                        </button>
                    </div>
                </div>
            </form>)}
            {isSuccessfullySubmitted && (
                <div className="alert alert-success" role="alert">Thank you for your submission, a member of our team will be in contact with you shortly.</div>
            )}
            <p className="form-messege"></p>
        </Fragment>
    )
}

export default ProjectForm;
